import { Component, ViewChild, ViewContainerRef, Input } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { QuestionnaireService } from '@app/shared/services/questionnaire.service';
import { environment } from '@environment/environment';
import { GuidanceNotesService } from '@shared/services/guidanceNotes.service';
import { GuidanceNote } from '@app/shared/models/guidanceNote';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GuidanceNotesEditorDialogComponent } from '@shared/components/dialogs/guidance-notes-editor-dialog/guidance-notes-editor-dialog.component';

@Component({
  selector: 'db-radio-wrapper',
  templateUrl: './radio-wrapper.component.html',
})

export class RadioWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef, static: true }) fieldComponent: ViewContainerRef;
  customFieldRadioDialogRefGN: MatDialogRef<GuidanceNotesEditorDialogComponent>;
  private guidanceNote = new GuidanceNote();
  @Input() sessionID: string;

  // tslint:disable-next-line:max-line-length
  constructor(private service: QuestionnaireService, private guidanceNotesService: GuidanceNotesService, private dialog: MatDialog) {
    super();
  }

  ngOnInit() {
    this.guidanceNotesService.getGuidanceNote(this.id, this.model['questionnaireId']).subscribe(([ gnarray ]) => {
      if (gnarray !== undefined) {
        this.guidanceNote.id = gnarray.id;
        this.guidanceNote.questionId = gnarray.questionId;
        this.guidanceNote.questionnaireId = gnarray.questionnaireId;
        this.guidanceNote.text = gnarray.text;
        this.guidanceNote.title = gnarray.title;
      }
    });

    if (this.guidanceNote.questionId === '') {
      this.guidanceNote.questionId = this.id;
      this.guidanceNote.questionnaireId = this.model['questionnaireId'];
      this.guidanceNote.text = '';
      this.guidanceNote.title = 'AutoGeneratedTitleFromDocBuilder';
    }
  }

  getSector(id) {
    return this.service.getSector(id);
  }

  showSector() {
    return environment.showSectors;
  }

  updateSessionList() {
    this.guidanceNotesService.addSessionToCache(this.model["sessionID"], this.guidanceNote.text).subscribe();
  }

  editGuidanceNotesWindow() {
    this.customFieldRadioDialogRefGN = this.dialog.open(GuidanceNotesEditorDialogComponent, {
      panelClass: 'db-dialog',
      data: {
        guidanceNote: this.guidanceNote
      }
    });
  }

  checkIfGuidanceNotesExists() {
    if (this.guidanceNote.text === '' || this.guidanceNote.text === null) {
      return false;
    }
    return true;
  }
}
